import styles from './Paragraph.module.scss';

export interface ParagraphProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  > {
  compact?: boolean;
  variant?: 'primary' | 'secondary' | 'negative';
  noPadding?: boolean;
  align?: 'left' | 'center' | 'right';
}

export const Paragraph = ({
  compact = false,
  variant = 'primary',
  noPadding = false,
  align = 'left',
  ...props
}: ParagraphProps) => {
  return (
    <p
      {...props}
      className={styles.paragraph}
      data-test-id="paragraph-container"
      data-compact={compact}
      data-variant={variant}
      data-no-padding={noPadding}
      data-align={align}
    />
  );
};
